<script lang="ts">
  export let groupId: string;
  export let points: Array<{ x: number; y: number }>;
  export let selected = false;

  $: path = points.length > 0
    ? points.map((point, index) => `${index === 0 ? "M" : "L"}${point.x} ${point.y}`).join(" ")
    : "";
</script>

{#if points.length > 1}
  <g
    class:tow-link--selected={selected}
    class="tow-link"
    data-tow-group-id={groupId}
    aria-hidden="true"
  >
    <path class="tow-link__casing" d={path} />
    <path class="tow-link__line" d={path} />
  </g>
{/if}
